import yup from 'utils/yup';

export const initialNotificationSettingsData = {
  employee_clock_out_of_bounds: true,
  schedule_notification_by_email: false,
  schedule_notification_by_mobile: true,
  overtime_notification: true,
  automatic_clockout: false,
  overtime_threshold: '' as any,
  clockout_threshold: '' as any,
  clock_in_reminder_time: '' as any,
  clock_in_reminder_reminder_mobile: false,
  clock_in_reminder_reminder_email: true,
  clock_out_reminder_time: '' as any,
  clock_out_reminder_reminder_mobile: false,
  clock_out_reminder_reminder_email: true,

  send_reminder_to_take_breaks: false,
  break_reminder_after_x_hours: null as any,
  send_reminder_for_no_show: false,
  send_reminder_for_late_clock_in: false,

  // California reminders
  cali_send_rest_break_reminder_after_hrs: '' as any,
  cali_send_meal_break_reminder_after_hrs: '' as any,
};

export const notificationSettingsValidation = yup.object().shape({
  overtime_threshold: yup.string().when('overtime_notification', {
    is: true,
    then: yup.string().required(),
    otherwise: yup.string(),
  }),
  clockout_threshold: yup.string().when('automatic_clockout', {
    is: true,
    then: yup.string().required(),
    otherwise: yup.string(),
  }),
  clock_in_reminder_time: yup.string().required(),
  clock_out_reminder_time: yup.string().required(),
});
